import { amazon_regions } from "../../Onboarding/components/onboardinghelper";

export function getAmazonLink(props: any) {
    let tempMarketplaceId: string = props.redux.current.target.warehouses?.[0]?.['marketplace_id'];
    let marketplace_id: any = '';
    amazon_regions.map(elem => {
        if (elem?.['marketplace_id'] === tempMarketplaceId)
            marketplace_id = elem?.['url'];
    });
    return marketplace_id?.toLowerCase();
}